import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { cmsSettings } from '../../../../../redux/cmsSettings/action';
import { selectCmsSettingsQueryItems } from '../../../../../redux/cmsSettings/selector';
import CMSComponent from '../components/cms.component';

const ManagementCMSSettings = () => {
  const dispatch = useAppDispatch()
  const cmsSettingsQuery = useSelector(selectCmsSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectCMSSettings, setSelectCMSSettings] = useState<any>([])

  const fetchCMSSettingsQueryById = () => {
    dispatch(cmsSettings.query({
      url: `https:///cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`,
      entity: 'cmsSettings',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectCMSSettings({ ...selectCMSSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchCMSSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectCMSSettings(cmsSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(cmsSettings.resetAction({ actionType: 'update' }))
    await dispatch(cmsSettings.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms`,
      entity: 'cmsSettings',
      jsonData: {
        Records: [
          selectCMSSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <CMSComponent
          handleInnerFormChange={handleInnerFormChange}
          selectCMSSettings={selectCMSSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementCMSSettings;